import { CircularLoading, useToast } from '@myhrbox/myhrbox-frontend-core';
import ROUTES from 'constants/routes';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import useMe from 'store/user/useMe';
import { getIsEmailNeedToBeConfirmed } from 'utils/user';
import AssessmentContent from './Content';

// Доп. обертка над основным компонентом для прохождения валидаций перед запросом тестирования
const Assessment = () => {
  const { t } = useTranslation();
  const { me, loading: meLoading } = useMe();
  const isEmailNeedToBeConfirmed = getIsEmailNeedToBeConfirmed(me);
  const { showErrorToast } = useToast();
  const navigate = useNavigate();
  const [isValid, setIsValid] = useState(false);

  useEffect(() => {
    if (isEmailNeedToBeConfirmed && !meLoading) {
      navigate(ROUTES.ASSESSMENT, { replace: true });
      showErrorToast(t('assessment.instruction.error.nonConfirmedEmail'));
    } else if (!meLoading) {
      setIsValid(true);
    }
  }, [me, meLoading]);

  if (meLoading || !isValid) {
    return <CircularLoading />;
  }

  return <AssessmentContent />;
};

export default Assessment;
